import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cee5410")

_pushScopeId("data-v-7cee5410")
const _hoisted_1 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "center title-2" }, " Résultat de la simulation ", -1)
const _hoisted_2 = {
  key: 0,
  class: "center"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "center title-3" }, " Les données saisies ne permettent pas encore de calculer le résultat ", -1)
const _hoisted_4 = { class: "buttons-container" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "item-name" }
const _hoisted_7 = { class: "item-value" }
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { class: "item-value" }
const _hoisted_10 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-3" }, " Coût des travaux ", -1)
const _hoisted_11 = { class: "item-name" }
const _hoisted_12 = { class: "item-number-value" }
const _hoisted_13 = { class: "item-name" }
const _hoisted_14 = { class: "item-number-value" }
const _hoisted_15 = { class: "item-name" }
const _hoisted_16 = { class: "item-number-value" }
const _hoisted_17 = { class: "important-value" }
const _hoisted_18 = { class: "item-name" }
const _hoisted_19 = { class: "item-number-value" }
const _hoisted_20 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-3" }, " Aides estimatives à déduire ", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "item-name" }
const _hoisted_24 = { class: "item-number-value" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "item-name" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "item-name" }
const _hoisted_29 = { class: "item-number-value" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "item-name" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "item-name" }
const _hoisted_34 = { class: "item-number-value" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "item-name" }
const _hoisted_37 = { class: "important-value" }
const _hoisted_38 = { class: "item-name" }
const _hoisted_39 = { class: "item-number-value" }
const _hoisted_40 = { class: "important-value" }
const _hoisted_41 = { class: "item-name" }
const _hoisted_42 = { class: "item-number-value" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_table_primes = _resolveComponent("table-primes")
  const _component_base_card = _resolveComponent("base-card")

  return ($props.simulation)
    ? (_openBlock(), _createBlock(_component_base_card, {
        key: 0,
        class: "display-resume"
      }, {
        default: _withId(() => [
          _hoisted_1,
          (!$setup.simulationValid)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _hoisted_3,
                _createVNode("div", _hoisted_4, [
                  _createVNode("dig-ui-standard-button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.checkValidity())),
                    disabled: $setup.loading
                  }, _toDisplayString($setup.t('showErrors')), 9, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.simulationValid)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_6, _toDisplayString($setup.t('Simulation.works')) + " : ", 1),
                  _createVNode("span", _hoisted_7, _toDisplayString($setup.t(`Simulation.WorksTypes.${$props.simulation.name}`)), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_8, _toDisplayString($setup.tc(
              `Simulation.WorksPrefix.${$props.simulation.name}`,
              $props.simulation?.count || 0,
            )) + " : ", 1),
                  _createVNode("span", _hoisted_9, _toDisplayString($props.simulation.count) + " " + _toDisplayString($setup.tc(
              `Simulation.WorksUnits.${$props.simulation.name}`,
              $props.simulation?.count || 0,
            )), 1)
                ]),
                _hoisted_10,
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_11, _toDisplayString($setup.t('Simulation.priceTotalHT')) + " : ", 1),
                  _createVNode("span", _hoisted_12, _toDisplayString($setup.formatEuro($props.simulation?.ht)), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_13, _toDisplayString($setup.t('Simulation.priceTotalHTCount', {
              unit: $setup.t(`Simulation.WorksUnits.${$props.simulation.name}`),
            })) + " : ", 1),
                  _createVNode("span", _hoisted_14, _toDisplayString($setup.formatEuro(($props.simulation?.ht || 0) / ($props.simulation?.count || 1))), 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_15, _toDisplayString($setup.t('Simulation.priceTotalTVA')) + " : ", 1),
                  _createVNode("span", _hoisted_16, _toDisplayString($setup.formatEuro($props.simulation.tva)), 1)
                ]),
                _createVNode("p", _hoisted_17, [
                  _createVNode("span", _hoisted_18, _toDisplayString($setup.t('Simulation.priceTotalTTC')) + " : ", 1),
                  _createVNode("span", _hoisted_19, _toDisplayString($setup.formatEuro($props.simulation.ttc)), 1)
                ]),
                _hoisted_20,
                ($props.simulation.taxBracket)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      _createVNode("p", null, [
                        ($props.simulation.cee[$props.simulation.taxBracket] !== 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_22, [
                              _createVNode("span", _hoisted_23, _toDisplayString($setup.t('Simulation.cee', { name: $props.simulation.ceeName })) + " : ", 1),
                              _createVNode("span", _hoisted_24, _toDisplayString($setup.formatEuro($props.simulation.cee[$props.simulation.taxBracket])), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ($props.simulation.cee[$props.simulation.taxBracket] === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_25, [
                              _createVNode("span", _hoisted_26, _toDisplayString($setup.t('Simulation.noCee')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("p", null, [
                        ($props.simulation.otherPrime !== 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_27, [
                              _createVNode("span", _hoisted_28, _toDisplayString($setup.t('Simulation.aides', { name: $props.simulation.otherName })) + " : ", 1),
                              _createVNode("span", _hoisted_29, _toDisplayString($setup.formatEuro($props.simulation.otherPrime)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ($props.simulation.otherPrime === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_30, [
                              _createVNode("span", _hoisted_31, _toDisplayString($setup.t('Simulation.noOther')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("p", null, [
                        ($props.simulation.renov[$props.simulation.taxBracket] !== 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_32, [
                              _createVNode("span", _hoisted_33, _toDisplayString($setup.t('Simulation.renov')) + " : ", 1),
                              _createVNode("span", _hoisted_34, _toDisplayString($setup.formatEuro($props.simulation.renov[$props.simulation.taxBracket])), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ($props.simulation.renov[$props.simulation.taxBracket] === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_35, [
                              _createVNode("span", _hoisted_36, _toDisplayString($setup.t('Simulation.noRenov')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("p", _hoisted_37, [
                        _createVNode("span", _hoisted_38, _toDisplayString($setup.t('Simulation.total')) + " : ", 1),
                        _createVNode("span", _hoisted_39, _toDisplayString($setup.formatEuro(
                ($props.simulation.cee[$props.simulation.taxBracket] || 0) +
                  ($props.simulation.renov[$props.simulation.taxBracket] || 0) +
                  ($props.simulation.otherPrime || 0),
              )), 1)
                      ]),
                      _createVNode("p", _hoisted_40, [
                        _createVNode("span", _hoisted_41, _toDisplayString($setup.t('Simulation.resteACharge')) + " : ", 1),
                        _createVNode("span", _hoisted_42, _toDisplayString($setup.formatEuro(
                ($props.simulation.ttc || 0) -
                  (($props.simulation.cee[$props.simulation.taxBracket] || 0) +
                    ($props.simulation.renov[$props.simulation.taxBracket] || 0) +
                    ($props.simulation.otherPrime || 0)),
              )), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!$props.simulation.taxBracket)
                  ? (_openBlock(), _createBlock("div", _hoisted_43, [
                      _createVNode(_component_table_primes, { simulation: $props.simulation }, null, 8, ["simulation"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("dig-input-checkbox", {
                  id: "emailUser",
                  checked: $props.simulation.emailUser,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateField('emailUser', $event.detail)))
                }, _toDisplayString($setup.t('Simulation.emailUser')), 41, ["checked"]),
                _createVNode("dig-input-checkbox", {
                  id: "emailContact",
                  checked: $props.simulation.emailContact,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateField('emailContact', $event.detail)))
                }, _toDisplayString($setup.t('Simulation.emailContact')), 41, ["checked"]),
                _createVNode("div", _hoisted_44, [
                  _createVNode("dig-ui-standard-button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.validate())),
                    disabled: $setup.loading
                  }, _toDisplayString($setup.t('validateSimulation')), 9, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})